export const initMap = () => {
	const mapEls = document.querySelectorAll(".partner-map");
	if (!mapEls.length) return;

	// Google API not ready (or not enqueued on this page).
	if (!window.google || !window.google.maps) {
		console.warn("Google Maps API not available.");
		return;
	}

	mapEls.forEach((el) => {
		const lat = parseFloat(el.dataset.lat || "");
		const lng = parseFloat(el.dataset.lng || "");
		const canvas = el.querySelector(".partner-map-canvas");

		if (!canvas || Number.isNaN(lat) || Number.isNaN(lng)) return;

		const position = { lat, lng };

		const map = new google.maps.Map(canvas, {
			zoom: 16,
			center: position,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
		});

		new google.maps.Marker({
			position,
			map,
		});
	});
};
